















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    iconName: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
});
